import { ZypeSubscriptionPlan } from "../../../../../core/services/PWS.types";
import { MagicLink } from "../../../../../core/ui";
import "./CoastSubscriptionDisclaimer.style.scss";

interface CoastSubscriptionDisclaimerProps {
    plan: ZypeSubscriptionPlan;
    isGift: boolean;
}

export const CoastSubscriptionDisclaimer = ({ plan, isGift }: CoastSubscriptionDisclaimerProps) => (
    <p className="component-coast-subscription-disclaimer">
        <span className="auto-renewal">Automatic Renewal:</span>
        Auto renewal means your subscription will be automatically renewed using the credit card you signed up with, at
        the same rate, and term. You will receive an e-mail notification from Coast Insider prior to your expiration
        date. For Coast Insider subscribers who have selected a one-year term, an auto-renewal notice will be sent at
        least 30 days prior to the expiration date, at which point you will be automatically charged US ${plan.amount}
        &nbsp; every
        {plan.interval_count > 1 ? ` ${plan.interval_count}` : ""}
        &nbsp;
        {plan.interval}
        {plan.interval_count > 1 ? "s" : ""}
        &nbsp; until you cancel. You will be notified prior to your automatic renewal if subscription prices change. Of
        course, you may cancel your subscription any time by sending an e-mail to: help@coasttocoastam.com. Sorry,
        partial months cannot be refunded. &nbsp; By subscribing you agree to{" "}
        {isGift ? "" : "Automatic Renewal as described above,"} our&nbsp;
        <MagicLink to="/terms/" target="_blank">
            Terms of Use
        </MagicLink>
        &nbsp;&amp;&nbsp;
        <MagicLink to="/privacy/" target="_blank">
            Privacy Policy
        </MagicLink>
        .
    </p>
);
